import { axiosInstance } from '@/lib/api';

export async function getPublicPlatformSettings(): Promise<{ apiBaseUrl: string | null }> {
  const { data } = await axiosInstance.get('/api/public/platform-settings');
  return data;
}
